import queryClient from './queryClient';

export default queryClient;
